<template>
    <div class="history-area ptb-100 bg-fafafb" id="metoda-atelierului">
        <div class="container">
            <div class="section-title">
                <span class="sub-title"><img src="../assets/images/star-icon.png" alt="image"> Mod de lucru</span>
                <h2>De la Idee la Implementare</h2>
            </div>

            <ol class="timeline history-timeline">
                <li class="timeline-block">
                    <!-- <div class="timeline-date">
                        <span>1</span>
                        Descoperire și Analiză
                        <sup>th</sup>
                    </div> -->

                    <div class="timeline-icon">
                        <span class="dot-badge"></span>
                    </div>

                    <div class="timeline-content">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-md-12">
                                <div class="content">
                                    <h3>Descoperire și Analiză</h3>
                                    <h5><i>Punem fundația: Care este provocarea reală?</i></h5>
                                    <p> Aceasta este etapa în care ascultăm cel mai mult. Organizăm workshop-uri cu echipa ta pentru a înțelege în profunzime obiectivele de business, procesele actuale și punctele slabe. Nu venim cu soluții prestabilite, ci diagnosticăm corect "ADN-ul" afacerii tale pentru a putea construi ceva cu adevărat personalizat.</p>
                                    <p> <b>Beneficiul tău: </b>Un document clar de analiză și specificații tehnice, agreat de ambele părți.</p>
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-12">
                                <div class="image" data-tilt>
                                    <img src="../assets/images/history/descoperire.jpg" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="timeline-block">
                    <!-- <div class="timeline-date">
                        <span>2</span>
                        Strategie și Arhitectură
                        <sup>th</sup>
                    </div> -->

                    <div class="timeline-icon">
                        <span class="dot-badge"></span>
                    </div>

                    <div class="timeline-content">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-md-12">
                                <div class="content">
                                    <h3>Strategie și Arhitectură</h3>
                                    <h5><i>Creăm planul soluției.</i></h5>
                                    <p>Odată ce am înțeles "de ce"-ul, ne concentrăm pe "cum". Arhitecții noștri software desenează structura sistemului, alegem cele mai potrivite tehnologii și creăm prototipuri vizuale (wireframes). Acum este momentul în care vezi pentru prima dată "scheletul" viitoarei tale aplicații și oferim feedback.</p>
                                    <p> <b>Beneficiul tău: </b>O arhitectură a sistemului, wireframes interactive și un plan de proiect detaliat, cu etape și termene clare.</p>
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-12">
                                <div class="image" data-tilt>
                                    <img src="../assets/images/history/strategie.jpg" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="timeline-block">
                    <!-- <div class="timeline-date">
                        <span>3</span>
                        Dezvoltare și Implementare
                        <sup>th</sup>
                    </div> -->

                    <div class="timeline-icon">
                        <span class="dot-badge"></span>
                    </div>

                    <div class="timeline-content">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-md-12">
                                <div class="content">
                                    <h3>Dezvoltare și Implementare</h3>
                                    <h5><i>Meșterii noștri intră în acțiune și construiesc.</i></h5>
                                    <p>Aici are loc dezvoltarea propriu-zisă. Lucrăm în cicluri de dezvoltare scurte (sprinturi), oferindu-ți acces la versiuni intermediare ale aplicației. Astfel, ai vizibilitate constantă asupra progresului și te asiguri că produsul se dezvoltă în direcția corectă, fără surprize la final.</p>
                                    <p> <b>Beneficiul tău: </b>Module funcționale ale aplicației, livrate incremental, pe care le poți testa pe parcurs.</p>
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-12">
                                <div class="image" data-tilt>
                                    <img src="../assets/images/history/dezvoltare.jpg" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="timeline-block">
                    <!-- <div class="timeline-date">
                        <span>4</span>
                        Testare și Calibrare
                        <sup>th</sup>
                    </div> -->

                    <div class="timeline-icon">
                        <span class="dot-badge"></span>
                    </div>

                    <div class="timeline-content">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-md-12">
                                <div class="content">
                                    <h3>Testare și Calibrare</h3>
                                    <h5><i>Verificăm fiecare îmbinare și șlefuim detaliile.</i></h5>
                                    <p>Calitatea este non-negociabilă. Supunem soluția unor teste riguroase – funcționale, de performanță, de securitate – pentru a ne asigura că funcționează impecabil în orice scenariu. Identificăm și eliminăm orice eroare, "calibrând" produsul pentru performanță maximă.</p>
                                    <p> <b>Beneficiul tău: </b>Un produs software stabil, sigur, performant și gata de a fi folosit de echipa ta.</p>
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-12">
                                <div class="image" data-tilt>
                                    <img src="../assets/images/history/testare.jpg" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>
                </li>

                <li class="timeline-block">
                    <!-- <div class="timeline-date">
                        <span>5</span>
                        Lansare și Parteneriat pe Termen Lung
                        <sup>th</sup>
                    </div> -->

                    <div class="timeline-icon">
                        <span class="dot-badge"></span>
                    </div>

                    <div class="timeline-content">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-md-12">
                                <div class="content">
                                    <h3>Lansare și Parteneriat pe Termen Lung</h3>
                                    <h5><i>Îți predăm cheile, dar rămânem alături de tine.</i></h5>
                                    <p>Implementăm soluția finală în mediul tău de lucru și oferim training echipei pentru a asigura o tranziție lină. Parteneriatul nostru nu se încheie aici. Rămânem disponibili pentru suport tehnic, mentenanță și viitoare dezvoltări, asigurându-ne că investiția ta continuă să aducă valoare pe măsură ce afacerea ta crește.</p>
                                    <p> <b>Beneficiul tău: </b>Soluția software implementată cu succes, o echipă instruită și un partener de încredere pentru viitor.</p>
                                </div>
                            </div>

                            <div class="col-lg-5 col-md-12">
                                <div class="image" data-tilt>
                                    <img src="../assets/images/history/lansare.jpg" alt="image">
                                </div>
                            </div>
                        </div>
                    </div>
                </li>                
            </ol>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ASMetodaAtelierului'
}
</script>